import { gql } from '@apollo/client';

// Datos del emisor para las facturas (admin).

export const COMPANY_SETTINGS = gql`
  query CompanySettings {
    companySettings {
      id
      name
      legal_name
      support_url
      co_nit
      co_tax_regime
      co_address
      co_phone
      co_dian_resolution
      us_tax_id
      us_address
      subscription_terms_es
      subscription_terms_en
    }
  }
`;

export const UPDATE_COMPANY_SETTINGS = gql`
  mutation UpdateCompanySettings($input: UpdateCompanySettingsInput!) {
    updateCompanySettings(input: $input) {
      id
      name
    }
  }
`;
